import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';

export default function CalculatorResults(props) {
  const { title, subtitle, list = [] } = props;

  return (
    <div
      className='calculator-results rounded-2xl backdrop-blur border border-white/20 px-6 md:px-10 py-6'
      style={{
        backgroundImage:
          'linear-gradient(176deg, hsla(var(--secondary) / 0.10) -29.28%, hsla(var(--secondary) / 0.50) 47.4%)'
      }}
    >
      <p className='title text-primary font-bold text-center mb-1'>{title}</p>
      <div className='subtitle text-center h3 font-normal drop-shadow-lg border-b pb-3'>{subtitle}</div>

      <ScrollArea type='auto'>
        <div className='list grid xs:grid-cols-[auto_auto] gap-y-3 gap-x-8 mt-6 max-w-[calc(100vw-8rem)] pb-1'>
          {list.map((item, index) => (
            <p key={index} className='item flex flex-col'>
              <span className='label text-nowrap'>{item.label}</span>
              <span className='value font-bold text-primary drop-shadow-2xl'>{item.value}</span>
            </p>
          ))}
        </div>
        <ScrollBar orientation='horizontal' classNames={{ thumb: 'rounded-none bg-background/30' }} />
      </ScrollArea>
    </div>
  );
}
